import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.BLOQUEIO.BLOQUEAR.BLOQUEAR_ITENS]({ state }) {
		await api.bloqueio.bloquearItens(state)
	},

	async [actionTypes.ITEM_ATA.BLOQUEIO.BLOQUEAR.DESBLOQUEAR_ITENS]({ state }) {
		await api.bloqueio.desbloquearItens(state)
	},
}
